// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"930":"ff4a5038","2230":"3d5ade53","2974":"9d6f3dfd","6547":"37af679a","8799":"3d5ade53"}[chunkId] + ".chunk.css";
};